module.exports = __webpack_public_path__ + "static/media/github-brands-solid.5c31f79d.svg";